module.exports = __webpack_public_path__ + "img/background-2.5c7a3106.jpg";